// API 서버 주소. 빌드 시 REACT_APP_API_HOST 로 지정한다 (예: https://breadum.iptime.org:9894).
// 지정하지 않으면 기존 운영 주소를 사용한다.
export const API_HOST = (
  process.env.REACT_APP_API_HOST || "https://api.alphanote.io"
).replace(/\/+$/, "");
